export default "どうやって\nなぜ\n幾つか\n方法"